import React, { useState } from "react";

const PersonDetailsSection = ({
  firstName,
  setFirstName,
  lastName,
  setLastName,
}) => {
  const [isEditing, setIsEditing] = useState(false);

  const handleFirstNameChange = (event) => {
    setFirstName(event.target.value);
  };

  const handleLastNameChange = (event) => {
    setLastName(event.target.value);
  };

  const handleCancel = () => {
    setIsEditing(false);
    setFirstName("Rishabh");
    setLastName("Sagar");
  };

  const handleSave = () => {
    setIsEditing(false);
  };

  const renderForm = () => {
    return (
      <div>
        <div className="mb-4">
          <label
            className="block text-gray-700 font-bold mb-2"
            htmlFor="firstName"
          >
            First name(s)*
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            placeholder="Rishabh"
            value={firstName}
            onChange={handleFirstNameChange}
          />
        </div>
        <div className="mb-4">
          <label
            className="block text-gray-700 font-bold mb-2"
            htmlFor="lastName"
          >
            Last name(s)*
          </label>
          <input
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            type="text"
            placeholder="Sagar"
            value={lastName}
            onChange={handleLastNameChange}
          />
        </div>
        <div className="flex justify-end">
          <button
            className="bg-gray-500 hover:bg-gray-700 text-white font-bold py-2 px-4 mr-2 rounded focus:outline-none focus:shadow-outline"
            onClick={handleCancel}
          >
            Cancel
          </button>
          <button
            className="text-white bg-black hover:scale-[1.05] transition-all font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            onClick={handleSave}
          >
            Save
          </button>
        </div>
      </div>
    );
  };

  const renderDisplay = () => {
    return (
      <div className="mb-4">
        <h2 className="font-bold text-gray-700 text-lg mb-2">Name</h2>
        <p className="text-gray-500 text-sm">
          {firstName} {lastName}
        </p>
        <button
          className="text-blue-500 hover:text-blue-700 text-sm"
          onClick={() => setIsEditing(true)}
        >
          Edit
        </button>
      </div>
    );
  };

  return <div>{isEditing ? renderForm() : renderDisplay()}</div>;
};

export default PersonDetailsSection;
